export default {
  title: 'Azioni rapide',
  send_push_notification: {
    label: 'Invia notifica push',
    description: 'Crea una nuova campagna',
  },
  email_campaign: {
    label: 'Campagna e-mail',
    description: 'Invia agli iscritti',
  },
  view_analytics: {
    label: 'Visualizza analisi',
    description: 'Prestazioni della campagna',
  },
};
